import { isEmpty } from 'lodash-es';
import { IFilterList } from 'wisestep-base';

import IJobSiteAdvanceSearch from '../types/JobSiteAdvanceSearch';

export const pushSearchFilters = (data: IJobSiteAdvanceSearch) => {
  const filtersArray: IFilterList[] = [];

  if (data.searchType && data.searchType.toString() !== '')
    filtersArray.push({
      tag: `Search Type: ${data.searchType}`,
      id: 'searchType',
    });

  if (data.searchOption && data.searchOption.toString() !== '')
    filtersArray.push({
      tag: `Search Option: ${data.searchOption}`,
      id: 'searchOption',
    });

  if (data.salary) {
    if (data.salary.salaryRateType) {
      filtersArray.push({
        tag: `Salary Rate Type: ${data.salary.salaryRateType}`,
        id: 'salaryRateType',
      });
    }
    if (data.salary.from) {
      filtersArray.push({
        tag: `Minimum Salary: ${data.salary.from}`,
        id: 'from',
      });
    }
    if (data.salary.to) {
      filtersArray.push({
        tag: `Maximum Salary: ${data.salary.to}`,
        id: 'to',
      });
    }
  }

  if (!isEmpty(data.languages))
    filtersArray.push({
      tag: `Languages: ${data.languages.join(',')}`,
      id: 'languages',
    });

  if (!isEmpty(data.highestLevelOfEducation))
    filtersArray.push({
      tag: `Level of Education: ${data.highestLevelOfEducation.join(',')}`,
      id: 'highestLevelOfEducation',
    });
  if (!isEmpty(data.countries))
    filtersArray.push({
      tag: `Countries: ${data.countries.join(',')}`,
      id: 'countries',
    });
  if (data.jobHours && data.jobHours !== '')
    filtersArray.push({
      tag: `Job Hours: ${data.jobHours}`,
      id: 'jobHours',
    });
  if (data.relocate && data.relocate.toString() !== '')
    filtersArray.push({
      tag: `Willing To Relocate: ${data.relocate === '1' ? 'Yes' : 'No'}`,
      id: 'relocate',
    });

  return filtersArray;
};
